import { fieldTypes, SectionHeader } from "@ucl/library";
import { FC } from "react";
import { FieldComplexV2 } from "./FieldComplexV2";
import "./ComplexFields.scss";
import { DepositApplicationReadDTO } from "@/types";
import { COMPLEX_FIELD_KEYS } from "@/constants/fieldKeys";

export interface CdarsOptInComplexValue {
  showHeader?: boolean;
  headerLabel?: string;
  readOnly?: boolean;
}

export interface CdarsOptInComplexFieldProps extends fieldTypes.BaseFieldProps<any> {
  formValue?: DepositApplicationReadDTO;
}

export const CdarsOptInComplexField: FC<CdarsOptInComplexFieldProps> = (props) => {
  const cdarsOptInComplexValue = props.complexFieldValue as CdarsOptInComplexValue;
  const readOnly = cdarsOptInComplexValue?.readOnly || props.readOnly;

  return (
    <section className="complex-field-container cdars-opt-in">
      <SectionHeader label={cdarsOptInComplexValue?.headerLabel || props.label} hidden={!cdarsOptInComplexValue?.showHeader} />
      <div className="complex-field-content">
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.CDARS_OPT_IN.IS_CDARS_OPT_IN_ENABLED}
          complexFieldProps={{
            disabled: readOnly,
          }}
        />
      </div>
    </section>
  );
};
